import clsx from 'clsx';
import { useFitText } from '@flyyer/use-fit-text';
import '../../../font.css';
import { CSSProperties, useEffect, useState } from 'react';
import { splitAndIdentifyPow } from '../../../store/banner/utils';
interface FitTextProps {
  text?: string;
  width?: number;
  height?: number;
  matrix?: number[];
  top?: number;
  left?: number;
  right?: number;
  color?: [number, number, number];
  textAlign?: CSSProperties['textAlign'];
  alignItems?: CSSProperties['alignItems'];
  whiteSpace?: CSSProperties['whiteSpace'];
  background?: [number, number, number, number];
  padding?: CSSProperties['padding'];
  rotate?: number;
  fontFamily?: CSSProperties['fontFamily'];
  fontWeight?: CSSProperties['fontWeight'];
  justifyContent?: CSSProperties['justifyContent'];
  borderRadius?: CSSProperties['borderRadius'];
}

export default function FitText({
  width,
  height,
  matrix = [0, 0, 0, 0, 0, 0, 0],
  text,
  top = 0,
  left = 0,
  right,
  color = [0, 0, 0],
  textAlign = 'center',
  whiteSpace = 'normal',
  background: [r, g, b, a] = [0, 0, 0, 0],
  padding = '0',
  rotate = 0,
  fontFamily = 'Primary',
  fontWeight = 'normal',
  alignItems,
  justifyContent,
}: FitTextProps) {
  const [refresh, setRefresh] = useState(false);
  const [fontSizePx, setFontSizePx] = useState<number>(0);
  const { splitText, pow } = splitAndIdentifyPow(`${text}`);
  const isRight = right !== undefined ? true : false;
  const { ref, fontSize, isCalculating } = useFitText(
    {
      maxFontSize: 1000,
      resolution: 10,
    },
    [width, height, text, refresh],
  );
  const className = clsx({ 'flyyer-wait': isCalculating });

  useEffect(() => {
    if (ref.current) {
      const computedStyle = window.getComputedStyle(ref.current);
      const fontSizeInPx = parseFloat(computedStyle.fontSize);
      setFontSizePx(fontSizeInPx);
    }
  }, [ref, fontSize, width, height, text, refresh]);

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        transition: 'transform 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
      }}
    >
      <div
        ref={ref}
        style={{
          position: 'absolute',
          display: 'flex',
          transition: 'height 500ms, top 500ms, left 500ms, right 500ms',
          transformOrigin: '0 50%',
          transform: `rotate(-${rotate}rad)`,
          top,
          ...(() => (isRight ? { right: right } : { left: left }))(),
          fontSize,
          fontFamily,
          fontWeight,
          letterSpacing: '0.1px',
          height,
          width,
          color: `rgb(${color[0]},${color[1]},${color[2]})`,
          textAlign,
          whiteSpace,
          background: `rgb(${r}, ${g}, ${b}, ${a})`,
          padding,
          alignItems,
          justifyContent,
        }}
        className={className}
      >
        <label style={{ whiteSpace: 'pre-wrap' }}>
          {splitText.reduce(
            (acc, acv, index) => [
              ...acc,
              ...(() => (index !== 0 ? [' '] : []))(),
              pow[index] && ['M2'].includes(acv) ? (
                <label>
                  <label>{acv[0].toLowerCase()}</label>
                  <label
                    style={{
                      position: 'relative',
                      fontSize: '70%',
                      top: `-${+fontSizePx * 0.35}px`,
                    }}
                  >
                    {acv[1]}
                  </label>
                </label>
              ) : (
                acv
              ),
            ],
            [] as any,
          )}
        </label>
      </div>
    </div>
  );
}
